// extracted by mini-css-extract-plugin
module.exports = {"description__body":"ServiceDescription_description__body__1Ib_j","description__text":"ServiceDescription_description__text__Sln91"};